import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const statusPanelWrap = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});
